export type SoundType =
  | 'diceRoll'
  | 'fury'
  | 'furyFirstRoll'
  | 'rescueByFive'
  | 'scoreSave'
  | 'tunnelStop'
  | 'overThousand'
  | 'victory'
  | 'emoteSent'
  | 'missedStraight'
  | 'zoneBonus'
  | 'zonePenalty';

const SOUND_PLACEHOLDER = '/sfx/placeholder.wav';

export const SOUND_VARIANTS: Record<SoundType, string[]> = {
  diceRoll: [
    '/sfx/dice-roll/roll1.mp3',
    '/sfx/dice-roll/roll2.mp3',
    '/sfx/dice-roll/roll3.mp3',
    '/sfx/dice-roll/roll4.mp3',
    '/sfx/dice-roll/roll5.mp3',
    '/sfx/dice-roll/roll6.mp3',
    '/sfx/dice-roll/roll7.mp3',
    '/sfx/dice-roll/roll8.mp3',
    '/sfx/dice-roll/roll9.mp3',
  ],
  fury: [
    '/sfx/fury/bust1.mp3',
  ],
  furyFirstRoll: [
    '/sfx/fury-first/first1.mp3',
  ],
  rescueByFive: [
    '/sfx/rescue/5save1.mp3',
  ],
  scoreSave: [
    '/sfx/score/save1.mp3',
  ],
  tunnelStop: [
    '/sfx/tunnel/stop1.mp3',
  ],
  overThousand: [
    '/sfx/over/over.mp3',
  ],
  victory: [
    '/sfx/victory/win1.mp3',
  ],
  emoteSent: [
    '/sfx/emote/emote1.mp3',
  ],
  missedStraight: [
    '/sfx/straight/missed_straight.mp3',
  ],
  // Strefy nie mają jeszcze własnych próbek – korzystają z istniejących,
  // pasujących wydźwiękiem. Do podmiany, gdy pojawią się dedykowane assety.
  zoneBonus: [
    '/sfx/rescue/5save1.mp3',
  ],
  zonePenalty: [
    '/sfx/fury/bust1.mp3',
  ],
};

const TUNNEL_RANGES = [
  { min: 200, max: 300 },
  { min: 700, max: 800 },
] as const;

export const isTunnelScore = (score: number): boolean => TUNNEL_RANGES
  .some(({ min, max }) => score >= min && score < max);

export const pickSoundVariant = (type: SoundType, rng: () => number = Math.random): string => {
  const variants = SOUND_VARIANTS[type] || [];
  if (!variants.length) return SOUND_PLACEHOLDER;
  const idx = Math.floor(rng() * variants.length);
  return variants[idx] || SOUND_PLACEHOLDER;
};
